import React from 'react';
import { connect } from 'react-redux';

import { dataIdPending, dataIdSend, dataIdFulfilled, dataIdRejected } from 'actions/DataIdActions';
import { Button } from 'react-bootstrap';

const dataFetchTimeout = 5000;

class QuotePdfButton extends React.Component {
  constructor(props) {
    super(props);

    this.maxCount = 1;
    this.count = 0;
  }

  componentDidMount = () => {
    const { quote } = this.props;
    if (!(quote.pdf && quote.pdf.web_link) && (quote.is_auto_generated || quote.is_authorized)) {
      this.timeout = setTimeout(this.fetchRemoteData, dataFetchTimeout);
    }
  };

  componentDidUpdate = prevProps => {
    const { quote, dataQuote } = this.props;

    if (
      prevProps.dataQuote.pending &&
      !dataQuote.pending &&
      (!dataQuote.data || !dataQuote.data.pdf || !dataQuote.data.pdf.web_link) &&
      this.count < this.maxCount
    ) {
      this.timeout = setTimeout(this.fetchRemoteData, dataFetchTimeout);
    }

    if (!prevProps.quote.is_authorized && quote.is_authorized) {
      this.timeout = setTimeout(this.fetchRemoteData, dataFetchTimeout);
    }
  };

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
  };

  fetchRemoteData = () => {
    const { quote, fetch } = this.props;
    this.count++;
    fetch(quote.id);
  };

  pdfRegenerate = () => {
    const { quote, pdfRegenerate } = this.props;
    this.count++;
    pdfRegenerate(quote.id);
  };

  render() {
    const { quote, dataQuote } = this.props;

    let pdfLink = null;
    if (quote.pdf && quote.pdf.web_link) {
      pdfLink = quote.pdf.web_link;
    } else if (!dataQuote.pending && dataQuote.data && dataQuote.data.pdf && dataQuote.data.pdf.web_link) {
      pdfLink = dataQuote.data.pdf.web_link;
    }

    if (pdfLink) {
      return (
        <>
          <a
            href={pdfLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-rounded btn btn-sm btn-default"
            onClick={e => e.stopPropagation()}
            key={'pdf_' + quote?.id}
          >
            <i className="far fa-file-pdf" /> PDF
          </a>
          <Button
            bsSize="sm"
            bsStyle="warning"
            className="btn-rounded"
            onClick={e => {
              this.pdfRegenerate();
              e.stopPropagation();
            }}
            key={'nopdf_' + quote?.id}
          >
            <i className="fas fa-sync" /> PDF
          </Button>
        </>
      );
    }
    return (
      <Button
        bsSize="sm"
        bsStyle="warning"
        className="btn-rounded"
        onClick={e => {
          this.pdfRegenerate();
          e.stopPropagation();
        }}
      >
        <i className="fas fa-sync" /> PDF
      </Button>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { quote } = ownProps;
  const dataQuote = state.dataId.quote[quote.id];

  return {
    dataQuote: dataQuote || { pending: false, data: {} },
  };
};
const mapDispatchToProps = dispatch => {
  const fetchUrl = id => `/api/quotes/${id}.json`;
  const pdfRegenerateUrl = id => `/api/quotes/${id}/regenerate.json`;

  const fetcherFunction = urlGetter => dataIdId => {
    const dataIdName = 'quote';
    const url = urlGetter(dataIdId);

    // add data to queue
    dispatch(dataIdPending(dataIdName, dataIdId));

    // finished callback will trigger an event
    const finishedCallback = response => {
      return dispatch(dataIdFulfilled(dataIdName, dataIdId, response));
    };
    // error callback will trigger an event
    const errorCallback = error => {
      return dispatch(dataIdRejected(dataIdName, dataIdId, error));
    };
    // dispatch fetching the data
    dispatch(dataIdSend(url, {}, finishedCallback, errorCallback, 'get'));
  };

  return {
    fetch: fetcherFunction(fetchUrl),
    pdfRegenerate: fetcherFunction(pdfRegenerateUrl),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuotePdfButton);
